import { NgModule } from '@angular/core';
import { provideNavConfig } from '@capital-access/common/navigation';
import { CommonRouterModule } from '@capital-access/common/router';
import { AiSearchNavConfigProvider } from './ai-search-nav-config.provider';
import { CanAccessAiSearchGuard } from './ai-search-navigation-guards';
import { AI_SEARCH_PATH } from './constants';

export const loadModule = () => import('@capital-access/ai-search/client').then(m => m.AiSearchClientModule);

@NgModule({
  imports: [
    CommonRouterModule.forFeature({
      authorized: [
        {
          path: AI_SEARCH_PATH,
          canActivate: [CanAccessAiSearchGuard],
          loadChildren: loadModule
        }
      ]
    })
  ],
  providers: [provideNavConfig(AiSearchNavConfigProvider), CanAccessAiSearchGuard]
})
export class AiClientLazyModule {}
